var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 222,
    viewBox: "0 0 244 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.635 218.95L116.047 219.321L25.1951 217.5C10.6495 196.359 1.36427 168.138 0.863281 132.835C3.32753 -39.329 214.658 -43.058 226.214 121.576C236.674 135.569 243.676 156.089 243.996 183.136C244.273 206.563 223.952 218.908 193.243 218.908C177.781 218.078 165.701 219.264 156.306 220.187C145.612 221.237 138.397 221.946 133.635 218.95Z",
    fill: "#EABE24",
    fillOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M217.511 216.66C222.441 222.654 29.0879 222.654 34.0185 216.659C29.0883 210.666 222.441 210.666 217.511 216.66Z",
    fill: "#C4C4C4",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.071 214.675C182.071 218.252 155.183 221.152 122.016 221.152C88.8485 221.152 61.9609 218.252 61.9609 214.675C61.9609 212.854 61.9609 209.965 61.9609 209.965C61.9609 209.965 105.733 210.554 122.016 210.554C142.814 210.554 182.071 209.974 182.071 209.974C182.071 209.974 182.071 213.341 182.071 214.675Z",
    fill: "#3C4C83"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.016,
    cy: 209.973,
    rx: 60.055,
    ry: 6.47652,
    fill: "#3B3E7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.596 187.008H131.894L139.679 210.559H120.381L112.596 187.008Z",
    fill: "#3B3E7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.887 187.008H127.185L134.97 210.559H115.672L107.887 187.008Z",
    fill: "#3C4C83"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.107 57.4119V180.547C222.107 184.407 218.979 187.536 215.119 187.536H34.9746C33.0353 187.536 31.2822 186.746 30.0151 185.472C28.7613 184.208 27.9865 182.469 27.9865 180.547V57.4119C27.9865 53.5519 31.1146 50.4238 34.9746 50.4238H215.119C216.26 50.4238 217.337 50.6969 218.289 51.1825C220.556 52.3374 222.107 54.693 222.107 57.4119Z",
    fill: "#3B3E7D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.576 57.5282V180.2C218.576 184.046 215.454 187.162 211.6 187.162H32.4337C30.4978 187.162 28.7478 186.376 27.4835 185.107C26.232 183.847 25.458 182.114 25.458 180.2V57.5282C25.458 53.6827 28.5805 50.5664 32.4337 50.5664H211.6C212.74 50.5664 213.815 50.8385 214.764 51.3222C217.028 52.4727 218.576 54.8195 218.576 57.5282Z",
    fill: "#3C4C83"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9901 57.1724V180.574C28.9901 181 29.0771 181.404 29.2348 181.773C29.7056 182.872 30.7979 183.638 32.0718 183.638H211.961C213.662 183.638 215.043 182.269 215.043 180.574V57.1724C215.043 57.0014 215.03 56.8327 215.001 56.6687C214.828 55.6266 214.122 54.7608 213.172 54.3521C212.974 54.269 212.767 54.2048 212.552 54.1644C212.361 54.1264 212.163 54.1074 211.961 54.1074H32.0718C30.3701 54.1074 28.9901 55.4807 28.9901 57.1724Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.949 79.8027C178.949 80.817 178.346 81.6387 177.602 81.6387H145.413C144.67 81.6387 144.066 80.817 144.066 79.8027C144.066 78.7893 144.669 77.9668 145.413 77.9668H177.602C178.346 77.9676 178.949 78.7893 178.949 79.8027Z",
    fill: "#DBE6F7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M191.801 95.4082C191.801 96.4225 190.976 97.2442 189.958 97.2442H145.909C144.892 97.2442 144.066 96.4225 144.066 95.4082C144.066 94.3948 144.891 93.5723 145.909 93.5723H189.958C190.976 93.5731 191.801 94.3948 191.801 95.4082Z",
    fill: "#DBE6F7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M111.938 170.682C111.938 171.695 110.557 172.518 108.854 172.518H35.1575C33.4554 172.518 32.074 171.696 32.074 170.682C32.074 169.668 33.454 168.846 35.1575 168.846H108.854C110.557 168.847 111.938 169.668 111.938 170.682Z",
    fill: "#DBE6F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M210.16 170.682C210.16 171.695 208.748 172.518 207.006 172.518H131.615C129.874 172.518 128.461 171.696 128.461 170.682C128.461 169.668 129.872 168.846 131.615 168.846H207.006C208.748 168.847 210.16 169.668 210.16 170.682Z",
    fill: "#DBE6F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210.332 111.862C210.332 112.837 209.193 113.628 207.786 113.628H146.935C145.53 113.628 144.389 112.838 144.389 111.862C144.389 110.887 145.529 110.096 146.935 110.096H207.786C209.193 110.096 210.332 110.887 210.332 111.862Z",
    fill: "#DBE6F7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M210.332 128.385C210.332 129.36 209.193 130.152 207.786 130.152H146.935C145.53 130.152 144.389 129.361 144.389 128.385C144.389 127.41 145.529 126.619 146.935 126.619H207.786C209.193 126.619 210.332 127.41 210.332 128.385Z",
    fill: "#DBE6F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.1 154.002H206.9C208.613 154.002 210 152.348 210 150.308V146.697C210 144.656 208.612 143.002 206.9 143.002H182.101C180.388 143.002 179 144.656 179 146.697V150.308C179 152.348 180.388 154.002 182.1 154.002Z",
    fill: "#DBE6F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.1 154.002H171.9C173.613 154.002 175 152.348 175 150.308V146.697C175 144.656 173.612 143.002 171.9 143.002H147.101C145.388 143.002 144 144.656 144 146.697V150.308C144 152.348 145.388 154.002 147.1 154.002Z",
    fill: "#DBE6F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M234 56.002C234 69.809 222.807 81.002 209.001 81.002C195.194 81.002 184 69.809 184 56.002C184 42.1949 195.194 31.002 209.001 31.002C222.807 31.002 234 42.1949 234 56.002Z",
    fill: "#E15858"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M208.659 64.0366C207.164 64.0366 205.954 63.0788 205.954 61.895L205.215 40.4795C205.215 39.2957 207.164 38.3379 208.659 38.3379C210.154 38.3379 212.264 39.2957 212.264 40.4795L211.364 61.895C211.364 63.0788 210.154 64.0366 208.659 64.0366Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M208.66 73.1446C210.154 73.1446 211.365 71.9336 211.365 70.4395C211.365 68.9454 210.154 67.7344 208.66 67.7344C207.166 67.7344 205.955 68.9454 205.955 70.4395C205.955 71.9336 207.166 73.1446 208.66 73.1446Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1322 71.3457V154.857H137.027V71.3457H132.204L132.248 71.2988L132.195 71.3457H32.1322Z",
    fill: "#DBE6F7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2816 64.8809H131.18V148.393H10.2816V64.8809Z",
    fill: "#1D38C8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44367 64.8809H126.342V148.393H5.44367V64.8809Z",
    fill: "#4F60D9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126.4 64.8379L70.4203 123.109C67.965 125.664 63.8763 125.664 61.4211 123.109L5.44095 64.8379L61.772 114.974C64.1369 117.078 67.7036 117.078 70.0685 114.974L126.4 64.8379Z",
    fill: "#1D38C8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5381 108.102L122.838 148.395H126.34V146.266L80.1424 105.176L77.5381 108.102Z",
    fill: "#1D38C8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43919 146.549V148.395H9.2579L54.5586 108.102L51.9543 105.176L5.43919 146.549Z",
    fill: "#1D38C8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M126.344 64.8809L69.879 115.099C67.6069 117.12 64.1816 117.12 61.9095 115.099L5.44477 64.8809H126.344Z",
    fill: "#707FFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3514 72.6959H109.198C110.59 72.6959 111.719 71.5675 111.719 70.1751C111.719 68.7827 110.59 67.6543 109.198 67.6543H67.3514C65.959 67.6543 64.8306 68.7827 64.8306 70.1751C64.8306 71.5675 65.959 72.6959 67.3514 72.6959Z",
    fill: "#707FFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5468 72.6959H58.7819C60.1743 72.6959 61.3027 71.5675 61.3027 70.1751C61.3027 68.7827 60.1743 67.6543 58.7819 67.6543H54.5468C53.1543 67.6543 52.0259 68.7827 52.0259 70.1751C52.0259 71.5675 53.1543 72.6959 54.5468 72.6959Z",
    fill: "#707FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a5ae8fab35ff3055429b5e56f914d01f.svg";
export { ForwardRef as ReactComponent };